module.exports = __webpack_public_path__ + "assets/retina_Angle75Detailed.bcfd73c4a0493aa28f2ea394850155ef.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/2x/retina_Angle75Detailed.png
// module id = 619
// module chunks = 0